export const PRODUCT_GROUPS = "product_groups";
export const INPUT_CHANGEVALUE = "product_groups_input_ChangeValue";
export const SELECT_CHANGEVALUE = "product_groups_Select_ChangeValue";

export const PRODUCT_GROUPS_ADD = "product_groups_add";
export const PRODUCT_GROUPS_ROW_DATA = "product_groups_Row_data";

export const PRODUCT_GROUPS_DELETE = "product_groups_deleted";

export const PRODUCT_GROUPS_SETROWDATA = "product_groups_set_rowdata";
export const MODEL_OPEN = "product_groups_model_open";
export const MODEL_CLOSE = "product_groups_model_close";

export const PRODUCT_GROUPS_LIST_SUCCESSFUL = "product_groups_list_successfull";
export const PRODUCT_GROUPS_ADD_SUCCESSFUL = "product_groups_add_successfull";
export const PRODUCT_GROUPS_ROW_DATA_SUCCESSFUL =
  "product_groups_row_data_successfull";
export const SET_PARAMS = "product_groups_set_params";

export const API_ERROR = "api_failed";
